export interface Article {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  image: string;
  tag: string;
  date: string;
  views: string;
  likes: string;
  big?: boolean;
}

export interface Category {
  key: string;
  name: string;
  short: string;
  desc: string;
  cover: string;
}

export const categories: Category[] = [
  {
    key: "sha",
    name: "沙雕比赛合集",
    short: "沙雕赛事",
    desc: "把奇奇怪怪的脑洞办成正式比赛，认真比赛的沙雕场面最解压。",
    cover: "https://readdy.ai/api/search-image?query=playful%20funny%20outdoor%20silly%20race%20competition%20scene%20adults%20in%20colorful%20mismatched%20costumes%20running%20while%20balancing%20giant%20objects%20and%20pillows%20on%20wooden%20planks%2C%20joyful%20crowd%20cheering%2C%20warm%20golden%20afternoon%20light%2C%20cream%20and%20coral%20tones%2C%20vibrant%20humorous%20atmosphere%2C%20editorial%20photo%2C%20clean%20natural%20background&width=1200&height=760&seq=cat-sha-01&orientation=landscape",
  },
  {
    key: "qi",
    name: "奇葩赛事盘点",
    short: "奇葩盘点",
    desc: "盘点全球最离谱的赛事规则，认真起来连规则自己都害怕。",
    cover: "https://readdy.ai/api/search-image?query=weird%20unusual%20sports%20event%20scene%20group%20of%20people%20competing%20to%20stay%20balanced%20on%20a%20giant%20floating%20rubber%20ring%2C%20hilarious%20funny%20moments%2C%20spectators%20laughing%20hard%2C%20warm%20bright%20outdoor%20daylight%2C%20clean%20minimal%20park%20background%2C%20humorous%20editorial%20photography&width=1200&height=760&seq=cat-qi-01&orientation=landscape",
  },
  {
    key: "min",
    name: "民间高手过招",
    short: "民间高手",
    desc: "高手在民间，三秒绝活藏不住，个个都是隐藏的扫地僧。",
    cover: "https://readdy.ai/api/search-image?query=folk%20masters%20street%20performance%20contest%20elder%20performing%20martial%20art%20moves%20while%20balancing%20on%20one%20leg%2C%20amazed%20crowd%20gathering%20in%20ancient%20town%20alley%2C%20warm%20evening%20lantern%20light%2C%20cultural%20yet%20humorous%2C%20cream%20and%20warm%20coral%20tones%2C%20documentary%20style%20photography&width=1200&height=760&seq=cat-min-01&orientation=landscape",
  },
  {
    key: "mi",
    name: "迷惑行为大赏",
    short: "迷惑行为",
    desc: "每一帧都让人挠头，看完只想问：这到底是在干嘛？",
    cover: "https://readdy.ai/api/search-image?query=confusing%20funny%20everyday%20behavior%20street%20collection%20scene%20person%20walking%20a%20dog%20while%20the%20dog%20holds%20the%20leash%20and%20walks%20them%2C%20amused%20puzzled%20bystanders%2C%20warm%20playful%20editorial%20photography%2C%20bright%20soft%20daylight%2C%20cream%20and%20teal%20accents%2C%20clean%20city%20background&width=1200&height=760&seq=cat-mi-01&orientation=landscape",
  },
  {
    key: "tu",
    name: "土味比赛现场",
    short: "土味现场",
    desc: "接地气的乡村欢乐现场，土到极致就是潮，快乐不打折。",
    cover: "https://readdy.ai/api/search-image?query=county%20fair%20funny%20live%20show%20stage%20with%20red%20banners%20and%20rural%20decorations%2C%20enthusiastic%20host%20and%20contestants%20dancing%2C%20nostalgic%20warm%20rustic%20scene%20with%20confetti%2C%20warm%20evening%20lighting%2C%20cheerful%20playful%20atmosphere%2C%20documentary%20style%20photography&width=1200&height=760&seq=cat-tu-01&orientation=landscape",
  },
];

export const articles: Article[] = [
  {
    id: 1,
    category: "sha",
    title: "首届「抱木桩原地转圈」大赛开锣，网友：这到底算体育还是玄学？",
    excerpt: "选手们抱着两米高的木桩原地旋转，拼的就是晕到最后一刻的钢铁意志。裁判打分不看姿势，只看谁先不吐。",
    image: "https://readdy.ai/api/search-image?query=playful%20funny%20outdoor%20silly%20race%20competition%20scene%20adults%20in%20colorful%20mismatched%20costumes%20running%20while%20balancing%20giant%20objects%20and%20pillows%20on%20wooden%20planks%2C%20joyful%20crowd%20cheering%2C%20warm%20golden%20afternoon%20light%2C%20cream%20and%20coral%20tones%2C%20vibrant%20humorous%20atmosphere%2C%20editorial%20photo%2C%20clean%20natural%20background&width=1200&height=800&seq=art-sha-01&orientation=landscape",
    tag: "首发报道",
    date: "今天",
    views: "12.8w",
    likes: "9612",
    big: true,
  },
  {
    id: 2,
    category: "sha",
    title: "全国「搬砖姿势大赛」冠军诞生：两根手指优雅托起一整箱",
    excerpt: "比谁搬得优雅的比赛你见过吗？冠军选手全程面带微笑，动作行云流水，被网友称为搬砖界的艺术体操。",
    image: "https://readdy.ai/api/search-image?query=humorous%20ridiculous%20contest%20scene%20people%20doing%20strange%20funny%20poses%20carrying%20boxes%20in%20a%20village%20courtyard%20surrounded%20by%20amused%20spectators%2C%20warm%20rustic%20tones%2C%20bright%20daylight%2C%20playful%20candid%20documentary%20style%20photography&width=800&height=560&seq=art-sha-02&orientation=landscape",
    tag: "现场直击",
    date: "昨天",
    views: "8.4w",
    likes: "6450",
  },
  {
    id: 3,
    category: "sha",
    title: "城市枕头大战联赛爆火，软实力选手靠「表情管理」逆袭夺冠",
    excerpt: "谁能想到，枕头大战的决胜局竟然比的是谁被打脸时的表情更淡定。软实力，此刻有了全新定义。",
    image: "https://readdy.ai/api/search-image?query=silly%20talent%20show%20stage%20with%20colorful%20decorations%20contestant%20attempting%20a%20funny%20face%20while%20holding%20a%20giant%20trophy%20with%20balloons%20and%20confetti%2C%20cheerful%20warm%20lighting%2C%20cream%20and%20coral%20color%20scheme%2C%20playful%20editorial%20photography&width=800&height=560&seq=art-sha-03&orientation=landscape",
    tag: "热梗",
    date: "前天",
    views: "6.1w",
    likes: "4890",
  },
  {
    id: 4,
    category: "qi",
    title: "盘点全球 10 大离谱赛事：不喘气憋笑也算比赛项目",
    excerpt: "从憋笑憋气到扛水赛跑，有些赛事规则认真到让人怀疑人生的意义。这份离谱清单，保你看完笑出腹肌。",
    image: "https://readdy.ai/api/search-image?query=weird%20unusual%20sports%20event%20scene%20group%20of%20people%20competing%20to%20stay%20balanced%20on%20a%20giant%20floating%20rubber%20ring%2C%20hilarious%20funny%20moments%2C%20spectators%20laughing%20hard%2C%20warm%20bright%20outdoor%20daylight%2C%20clean%20minimal%20park%20background%2C%20humorous%20editorial%20photography&width=1200&height=800&seq=art-qi-01&orientation=landscape",
    tag: "深度盘点",
    date: "今天",
    views: "15.2w",
    likes: "12030",
    big: true,
  },
  {
    id: 5,
    category: "qi",
    title: "「头顶水桶竞速赛」现场：跑得越快，泼得越多，笑得越惨",
    excerpt: "这是一场速度与泼水的博弈，赢家不一定最快，但一定是泼得最少又跑得最稳的那位。",
    image: "https://readdy.ai/api/search-image?query=strange%20contest%20city%20plaza%20people%20racing%20while%20carrying%20buckets%20of%20water%20on%20their%20head%2C%20splashing%20water%20everywhere%2C%20comedic%20moments%2C%20warm%20sunny%20day%2C%20clean%20urban%20background%2C%20playful%20documentary%20photography&width=800&height=560&seq=art-qi-02&orientation=landscape",
    tag: "名场面",
    date: "昨天",
    views: "7.9w",
    likes: "5320",
  },
  {
    id: 6,
    category: "qi",
    title: "堆箱子大赛的尽头是什么？参赛者纷纷表示：是恐高",
    excerpt: "规则简单到只要把箱子尽量堆高不倒下，可站在十米高空时，大家才意识到这才是真正的胆量测试。",
    image: "https://readdy.ai/api/search-image?query=absurd%20competition%20of%20building%20tallest%20pile%20of%20colorful%20cardboard%20boxes%20participants%20climbing%20ladders%20carefully%2C%20playful%20warm%20outdoor%20setting%2C%20cream%20and%20coral%20tones%2C%20humorous%20editorial%20photography&width=800&height=560&seq=art-qi-03&orientation=landscape",
    tag: "趣味",
    date: "前天",
    views: "5.6w",
    likes: "4210",
  },
  {
    id: 7,
    category: "min",
    title: "民间高手「金鸡独立拉二胡」，围观群众：先别鼓掌怕他笑场",
    excerpt: "大爷一腿站桩、一腿劈叉还能稳拉整首曲子，围观群众看得屏住呼吸，就怕他一高兴破了功。",
    image: "https://readdy.ai/api/search-image?query=folk%20masters%20street%20performance%20contest%20elder%20performing%20martial%20art%20moves%20while%20balancing%20on%20one%20leg%2C%20amazed%20crowd%20gathering%20in%20ancient%20town%20alley%2C%20warm%20evening%20lantern%20light%2C%20cultural%20yet%20humorous%2C%20documentary%20style%20photography&width=1200&height=800&seq=art-min-01&orientation=landscape",
    tag: "绝活",
    date: "今天",
    views: "18.6w",
    likes: "15400",
    big: true,
  },
  {
    id: 8,
    category: "min",
    title: "农村大姐「抛农具杂技」现场惊呆全场，锄头在她手里像有了生命",
    excerpt: "镰刀、锄头、簸箕轮番上阵，每一件农具都被她玩出了新花样，网友直呼这是被种地耽误的杂技演员。",
    image: "https://readdy.ai/api/search-image?query=rural%20master%20demonstrating%20impressive%20yet%20funny%20skill%20juggling%20farm%20tools%20villagers%20gathering%20around%2C%20golden%20warm%20light%2C%20cream%20tones%2C%20documentary%20style%20photography&width=800&height=560&seq=art-min-02&orientation=landscape",
    tag: "高手在民间",
    date: "昨天",
    views: "9.3w",
    likes: "7120",
  },
  {
    id: 9,
    category: "min",
    title: "「旋转盘子百步穿杨」挑战赛：民间技艺的尽头是精准得离谱",
    excerpt: "旋转的盘子上放水杯，还要隔空抛接命中目标，民间高手把「花活」玩成了硬核物理实验。",
    image: "https://readdy.ai/api/search-image?query=folk%20master%20competition%20of%20extremely%20precise%20yet%20silly%20throws%20hitting%20targets%20with%20spinning%20plates%2C%20warm%20market%20background%2C%20cream%20and%20warm%20coral%20tones%2C%20playful%20documentary%20photography&width=800&height=560&seq=art-min-03&orientation=landscape",
    tag: "硬核",
    date: "3天前",
    views: "4.8w",
    likes: "3890",
  },
  {
    id: 10,
    category: "mi",
    title: "迷惑行为大赏：狗狗遛主人遛出了遛狗界的最高境界",
    excerpt: "当牵绳两端互换角色，狗狗带着主人满街跑的画面，让人忍不住想问：到底谁遛谁？",
    image: "https://readdy.ai/api/search-image?query=confusing%20funny%20everyday%20behavior%20street%20collection%20scene%20person%20walking%20a%20dog%20while%20the%20dog%20holds%20the%20leash%20and%20walks%20them%2C%20amused%20puzzled%20bystanders%2C%20warm%20playful%20editorial%20photography%2C%20bright%20soft%20daylight%2C%20cream%20and%20teal%20accents%2C%20clean%20city%20background&width=1200&height=800&seq=art-mi-01&orientation=landscape",
    tag: "本期最佳",
    date: "今天",
    views: "22.1w",
    likes: "18300",
    big: true,
  },
  {
    id: 11,
    category: "mi",
    title: "迷惑穿搭图鉴：当你的同事把「奇怪」穿成了时尚宣言",
    excerpt: "从反穿羽绒服到自带板凳的皮鞋，每一套迷惑穿搭背后，都有一个自信到发光的主人。",
    image: "https://readdy.ai/api/search-image?query=funny%20weird%20fashion%20display%20on%20street%20creative%20homemade%20outfits%20bystanders%20puzzled%2C%20colorful%20warm%20daylight%2C%20clean%20street%20background%2C%20playful%20editorial%20photography&width=800&height=560&seq=art-mi-02&orientation=landscape",
    tag: "图鉴",
    date: "昨天",
    views: "11.7w",
    likes: "9860",
  },
  {
    id: 12,
    category: "mi",
    title: "「雨伞鞋」迷惑现场：下雨天的尽头是给脚也撑把伞",
    excerpt: "看到这双自带雨伞的鞋，网友沉默了五秒，然后默默转发：这到底算机智还是算迷惑？",
    image: "https://readdy.ai/api/search-image?query=absurd%20puzzling%20public%20invention%20moment%20shoes%20with%20tiny%20umbrellas%20attached%2C%20funny%20composition%2C%20warm%20clean%20street%20background%2C%20cream%20and%20teal%20tones%2C%20playful%20product%20style%20photography&width=800&height=560&seq=art-mi-03&orientation=landscape",
    tag: "沙雕发明",
    date: "前天",
    views: "6.9w",
    likes: "5670",
  },
  {
    id: 13,
    category: "tu",
    title: "乡村「独轮车拉菜大赛」现场：土味赛事也有热血赛点",
    excerpt: "独轮车、菜筐、田埂，这些土味元素凑到一起，竟拼出了一种属于乡村的燃与欢乐。",
    image: "https://readdy.ai/api/search-image?query=rural%20fun%20contest%20live%20stage%20people%20racing%20wheelbarrows%20carrying%20vegetables%20crowd%20cheering%2C%20dusty%20warm%20country%20scene%2C%20warm%20evening%20lighting%2C%20cheerful%20playful%20atmosphere%2C%20documentary%20photography&width=1200&height=800&seq=art-tu-01&orientation=landscape",
    tag: "现场报道",
    date: "今天",
    views: "10.5w",
    likes: "8220",
    big: true,
  },
  {
    id: 14,
    category: "tu",
    title: "镇上的「乡村才艺夜」炸场：自制二胡一响，全场土嗨全开",
    excerpt: "没有专业设备，全靠一颗想赢的心。自制乐器配土的可爱，这大概就是最淳朴的快乐。",
    image: "https://readdy.ai/api/search-image?query=local%20grassroots%20talent%20show%20rural%20stage%20at%20night%20performers%20with%20homemade%20instruments%20colorful%20lights%2C%20warm%20festive%20playful%20atmosphere%2C%20nostalgic%20rural%20scene%2C%20documentary%20photography&width=800&height=560&seq=art-tu-02&orientation=landscape",
    tag: "才艺夜",
    date: "昨天",
    views: "7.2w",
    likes: "5930",
  },
  {
    id: 15,
    category: "tu",
    title: "村口「簸箕颠大米」挑战赛：土到极致就是潮，快乐不打折",
    excerpt: "颠米、颠豆、颠花生，大妈们把簸箕颠出了专业水平，现场笑点与节奏齐飞。",
    image: "https://readdy.ai/api/search-image?query=county%20fair%20funny%20live%20show%20stage%20with%20red%20banners%20and%20rural%20decorations%20enthusiastic%20host%20and%20contestants%20dancing%2C%20nostalgic%20warm%20rustic%20scene%20with%20confetti%2C%20warm%20evening%20lighting%2C%20cheerful%20playful%20atmosphere&width=800&height=560&seq=art-tu-03&orientation=landscape",
    tag: "土味名场面",
    date: "3天前",
    views: "5.1w",
    likes: "4130",
  },
];

export const hotTitles: { rank: number; title: string; count: string }[] = [
  { rank: 1, title: "狗狗遛主人迷惑行为大赏", count: "224万围观" },
  { rank: 2, title: "民间高手金鸡独立拉二胡", count: "186万围观" },
  { rank: 3, title: "全球 10 大离谱赛事盘点", count: "152万围观" },
  { rank: 4, title: "首届抱木桩原地转圈大赛", count: "128万围观" },
  { rank: 5, title: "迷惑穿搭图鉴又更新了", count: "117万围观" },
  { rank: 6, title: "搬砖姿势大赛冠军出炉", count: "84万围观" },
  { rank: 7, title: "城市枕头大战联赛战报", count: "61万围观" },
  { rank: 8, title: "乡村独轮车拉菜现场", count: "105万围观" },
  { rank: 9, title: "土味才艺夜炸场实录", count: "72万围观" },
  { rank: 10, title: "堆箱子大赛恐高现场", count: "56万围观" },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: "每日大赛多久更新一次？",
    a: "我们会每天整理并更新沙雕比赛合集、奇葩赛事盘点、民间高手过招、迷惑行为大赏和土味比赛现场等内容，保证你每天都有新鲜的快乐可以围观。",
  },
  {
    q: "这些奇葩比赛都是真实存在的吗？",
    a: "每日大赛的内容主要来自全球各地真实举办的趣味赛事、民间活动与网络热点，我们会以轻松娱乐的方式进行盘点与分享。个别内容会做戏剧化演绎，请以现场为准。",
  },
  {
    q: "我可以投稿身边发现的奇葩比赛吗？",
    a: "当然可以！如果你身边也有离谱又好玩的民间赛事或迷惑现场，欢迎通过页面底部的联系邮箱投稿，一经选用我们会第一时间和你联系并署名分享。",
  },
  {
    q: "网站上的内容是否可以转载？",
    a: "出于对原创作者和现场参与者的尊重，转载请务必注明来源「每日大赛」并保留原文链接。如需商业用途，请先通过底部邮箱与我们取得联系授权。",
  },
  {
    q: "如何联系每日大赛团队？",
    a: "你可以在页面底部的订阅区留下邮箱接收每日快乐精选，也可以通过 hello@daily-race.cn 与我们取得联系，我们会尽快回复你。",
  },
];